import { createApiInstance } from "api/config";

const api = createApiInstance();

// Goals
// Grape: app/futurelab/api/v1/goals.rb
export const getGoals = async () => {
  return await api.get('/goals');
}